import React, { FC } from 'react';
import { NavLinkProps } from '@v2/pages/machines/common/components/Header/MachinesHeaderV2/types';
import Selectors from '@styles/selectors';
import i18n from 'i18n-js';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { injectConditionalObject } from '@helpers';

const NavLink: FC<NavLinkProps> = ({ title, selected, onPress, testID, capitalize }) => {
  return (
    <Selectors
      {...{
        scale,
        font,
        selected,
        variant: 'L',
        text: i18n.t(title),
        onPress,
        testID,
        // nl stores some period labels lowercase ('jaar'/'week'); title-case the selector to fix casing without touching other locales (SF-5263)
        ...injectConditionalObject(!!capitalize, { textStyleOverride: { textTransform: 'capitalize' } }),
      }}
    />
  );
};

export {NavLink};
